import React from "react";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Chip from '@mui/material/Chip';
import CSVReader from 'react-csv-reader';

const UploadTsv = () => {
    return (
        <div>
            <Chip icon={<UploadFileIcon />} color="primary" label="UPLOAD TSV FILE" sx={{ bgcolor: '#4575B4', color: 'white' }} />
        </div>
    );
}

const TsvUploader = (props) => {

    return (
        <CSVReader
            style={{float:"left"}}
            cssClass="react-csv-input"
            accept = {".csv, .txt, .tsv"}
            inputStyle = {{display: 'none'}}
            label ={<UploadTsv/>}
            onFileLoaded={props.uploadTsv}
        />
    );
}

export default TsvUploader;